var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10.75V8.25C5.5 4.79822 8.29822 2 11.75 2C15.2018 2 18 4.79822 18 8.25V10.75C19.3807 10.75 20.5 11.8693 20.5 13.25V19.5C20.5 20.8807 19.3807 22 18 22H5.5C4.11929 22 3 20.8807 3 19.5V13.25C3 11.8693 4.11929 10.75 5.5 10.75ZM15.5 8.25V10.75H8V8.25C8 6.17893 9.67893 4.5 11.75 4.5C13.8211 4.5 15.5 6.17893 15.5 8.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLock);
export default __webpack_public_path__ + "static/media/white-lock.c8d3bd388b1b81ee7a93497cc5889914.svg";
export { ForwardRef as ReactComponent };